import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';

const PATH_DYNAMIC_BITCOIN  = '/genome';
const PATH_GENE_DETAIL      = '/genome/:tokenId';
const PATH_MINESWEEPER      = '/genome/:tokenId/games/minesweeper';

export const DynamicBitcoinRoutesConfig: {
  [key: string]: RouteConfiguration;
} = {
  Index: {
    path: PATH_DYNAMIC_BITCOIN,
    generatePath: () => PATH_DYNAMIC_BITCOIN,
  },
  GeneDetail: {
    path: PATH_GENE_DETAIL,
    generatePath: (tokenId: string) => `/genome/${tokenId}`,
  },
  Minesweeper: {
    path: PATH_MINESWEEPER,
    generatePath: (tokenId: string) => `/genome/${tokenId}/games/minesweeper`,
  },
};

const LoadableDynamicBitcoin: LoadableComponent<any> = loadable(
  async () => import('./screens').then(m => m.DynamicBitcoin),
  { fallback: <QueryLoadingAbsolute /> },
);

const LoadableGeneDetail: LoadableComponent<any> = loadable(
  async () => import('./screens').then(m => m.GeneDetail),
  { fallback: <QueryLoadingAbsolute /> },
);

const LoadableMinesweeper: LoadableComponent<any> = loadable(
  async () => import('./games/MinesweeperGame').then(m => m.MinesweeperGame),
  { fallback: <QueryLoadingAbsolute /> },
);

export function DynamicBitcoinRoutes() {
  return (
    <>
      {/* Most specific first */}
      <Route path={PATH_MINESWEEPER} exact component={LoadableMinesweeper} />
      <Route path={PATH_GENE_DETAIL} exact component={LoadableGeneDetail} />
      <Route path={PATH_DYNAMIC_BITCOIN} exact component={LoadableDynamicBitcoin} />
    </>
  );
}
